export enum ShopTagSize {
  NotSet = 'NotSet',
  LessThanMillion = 'LessThanMillion',
  BetweenMillionAndTwoMillion = 'BetweenMillionAndTwoMillion',
  OverTwoMillion = 'OverTwoMillion'
}

export const ShopTagSizeToLabel: { [key: string]: string } = {
  [ShopTagSize.NotSet]: 'Not set',
  [ShopTagSize.LessThanMillion]: 'Less than one million',
  [ShopTagSize.BetweenMillionAndTwoMillion]: 'Between one and two million',
  [ShopTagSize.OverTwoMillion]: 'Over two million'
}

export const ShopTagSizeToList = Object.values(ShopTagSize).map((size) => ({
  label: ShopTagSizeToLabel[size],
  value: size
}))
